module.exports = __webpack_public_path__ + "static/docker-c16f6346d0737e215fbafbb6f0ac2ac7.png";